export default __webpack_public_path__ + "assets/purple-sky-with-stars-f7a8e83146f48240a601facb121ab205.svg";